import Middlewares from '../Middlewares/Index';

/**
 * Fleet / Route / Trip TMS routes (feature 001-fleet-route-trips).
 * Roles (server-enforced): SuperAdmin | service | distributioncentermanager.
 * Lazy-loaded so the TMS pages stay out of the main bundle.
 */
const fleet = [
    {
        path: '/fleet/trucks',
        name: 'fleet.trucks.index',
        component: () => import(/* webpackChunkName: "FleetTrucks" */'@/views/SuperAdmin/Fleet/Trucks/TruckList.vue'),
        meta: {
            middleware: [Middlewares.auth],
        },
    },
    {
        path: '/fleet/routes',
        name: 'fleet.routes.index',
        component: () => import(/* webpackChunkName: "FleetRoutes" */'@/views/SuperAdmin/Fleet/Routes/RouteList.vue'),
        meta: {
            middleware: [Middlewares.auth],
        },
    },
    {
        path: '/fleet/routes/builder',
        name: 'fleet.routes.builder',
        component: () => import(/* webpackChunkName: "FleetRoutes" */'@/views/SuperAdmin/Fleet/Routes/MapRouteBuilder.vue'),
        meta: {
            middleware: [Middlewares.auth],
        },
    },
    {
        path: '/fleet/rounds',
        name: 'fleet.rounds.planner',
        component: () => import(/* webpackChunkName: "FleetTrips" */'@/views/SuperAdmin/Fleet/Rounds/RoundPlanner.vue'),
        meta: {
            middleware: [Middlewares.auth],
        },
    },
    {
        path: '/fleet/trips',
        name: 'fleet.trips.board',
        component: () => import(/* webpackChunkName: "FleetTrips" */'@/views/SuperAdmin/Fleet/Trips/TripBoard.vue'),
        meta: {
            middleware: [Middlewares.auth],
        },
    },
    {
        path: '/fleet/trips/:id',
        name: 'fleet.trips.detail',
        component: () => import(/* webpackChunkName: "FleetTrips" */'@/views/SuperAdmin/Fleet/Trips/TripDetail.vue'),
        meta: {
            middleware: [Middlewares.auth],
        },
    },
    {
        path: '/fleet/stops/incoming',
        name: 'fleet.stops.incoming',
        component: () => import(/* webpackChunkName: "FleetTrips" */'@/views/SuperAdmin/Fleet/Trips/StopIncoming.vue'),
        meta: {
            middleware: [Middlewares.auth],
        },
    },
    {
        path: '/fleet/live',
        name: 'fleet.live',
        component: () => import(/* webpackChunkName: "FleetTrips" */'@/views/SuperAdmin/Fleet/Trips/LiveMap.vue'),
        meta: {
            middleware: [Middlewares.auth],
        },
    },
    {
        path: '/fleet/reports/volume',
        name: 'fleet.reports.volume',
        component: () => import(/* webpackChunkName: "FleetReports" */'@/views/SuperAdmin/Fleet/Reports/VolumeDashboard.vue'),
        meta: {
            middleware: [Middlewares.auth],
        },
    },
    {
        path: '/fleet/reports/daily',
        name: 'fleet.reports.daily',
        component: () => import(/* webpackChunkName: "FleetReports" */'@/views/SuperAdmin/Fleet/Reports/DailyReport.vue'),
        meta: {
            middleware: [Middlewares.auth],
        },
    },
    {
        path: '/fleet/reports/timetable-variance',
        name: 'fleet.reports.timetable',
        component: () => import(/* webpackChunkName: "FleetReports" */'@/views/SuperAdmin/Fleet/Reports/TimetableVariance.vue'),
        meta: {
            middleware: [Middlewares.auth],
        },
    },
    {
        path: '/fleet/reports/problems',
        name: 'fleet.reports.problems',
        component: () => import(/* webpackChunkName: "FleetReports" */'@/views/SuperAdmin/Fleet/Reports/Problems.vue'),
        meta: {
            middleware: [Middlewares.auth],
        },
    },
];

export default fleet;
